import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ActionsComponent } from './actions.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ActionsComponent],
  imports: [CommonModule, RouterModule],
  exports: [ActionsComponent]
})
export class ActionsModule {}
